export default "__VITE_ASSET__CE1S8kOW__"